(function () {
  function trimTrailingEmptyRteBlocks(container) {
    if (!container) return;

    while (container.lastElementChild) {
      const el = container.lastElementChild;
      const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      const hasContent = el.querySelector('img, video, iframe, svg, table, ul, ol, blockquote');

      if (!text && !hasContent) {
        el.remove();
      } else {
        break;
      }
    }
  }

  function initRteTrim() {
    document.querySelectorAll('.product__description.rte').forEach(trimTrailingEmptyRteBlocks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRteTrim);
  } else {
    initRteTrim();
  }

  document.addEventListener('shopify:section:load', initRteTrim);
})();
